import { Vue, Component, Watch } from 'vue-property-decorator'
import CustomersAccessList from '@/components/dashboard/customers-access/customers-access-list/CustomersAccessList.component.vue'
import { CustomerAccess } from '@/types'
import Axios from 'axios'

@Component({
  components: {
    CustomersAccessList
  }
})
export default class CustomersAccessPage extends Vue {
  loadingData: boolean = false
  items: CustomerAccess[] = []
  page = 1
  totalPage = 1

  @Watch('page')
  changePage (value:number, oldValue:number) {
    this.loadCustomersAccess()
  }

  mounted () {
    this.loadCustomersAccess()
  }

  loadCustomersAccess () {
    this.loadingData = true
    Axios.get('/customers', {
      params: {
        page: this.page
      }
    }).then(response => {
      this.items = response.data.data
      this.totalPage = response.data.last_page
      this.page = response.data.current_page
      this.loadingData = false
    })
  }
}
